import {Injectable} from "@angular/core";
import {DxAuthenticationStrategy} from "./dx-authentication-strategy";
import {Observable} from "rxjs/index";
import {DxAuthentication} from "../../../domain/authentication/dx-athentication";
import {DxHttpDispatcher} from "../../../../dx-core/services/dx-http-dispatcher.service";
import {DxOperationResultType} from "../../../../dx-core/domain/common/dx-operation-result-type";
import {fromPromise} from "rxjs/internal/observable/fromPromise";
import {DxConfigService} from "../../../../dx-core/services/dx-config.service";
import {HttpHeaders} from "@angular/common/http";
import {DxEncryptionStrategyType} from "../../../../dx-core/config/dx-encryptions-type";
import {DxEncryptionService} from "../../../../dx-core/services/dx-encryption.service";
import {DxObjectMapper} from "../../../../dx-core/services/dx-object-mapper.service";
import {DxKeycloakUser} from "../../../domain/user/dx-keycloak-user";
import {DxAppError} from "../../../../dx-core/domain/error/dx-app-error";
import {DxUserRole} from "../../../domain/user/dx-user-role";
import {DxKeycloakUtils} from "../../utils/dx-keycloak-utils";


/**
 * Стратегия аунтификации пользователя при помощи сервиса Keycloak.
 * @publicApi
 */
@Injectable()
export class DxKeycloakAuthenticationStrategy implements DxAuthenticationStrategy {
  public static KEYCLOAK_ACCESS_TOKEN: string = 'access_token';
  public static KEYCLOAK_REFRESH_TOKEN: string = 'refresh_token';
  public static _KEYCLOAK_TOKEN_EXP_TIME: string = 'exp';

  private readonly _serverUrl: string;
  private readonly _realm: string;
  private readonly _clientId: string;

  constructor(private _http: DxHttpDispatcher,
              private _configService: DxConfigService,
              private _mapper: DxObjectMapper,
              private _encryptor: DxEncryptionService) {
    this._serverUrl = this._configService.keycloakServerUrl;
    this._realm = this._configService.keycloakRealm;
    this._clientId = this._configService.keycloakClientId;
  }


  public authenticate(login: string, password: string): Observable<DxAuthentication> {
    if(!this._serverUrl) throw  new DxAppError('Не задан адрес сервиса аунтфикации Keycloak!');
    if(!this._realm) throw  new DxAppError('Не задан realm!');
    if(!this._clientId) throw  new DxAppError('Не задан идентификатор клиента Keycloak!');

    const authentication: DxAuthentication = new DxAuthentication();
    const promise: Promise<DxAuthentication> = new Promise((resolve) => {
      const path = DxKeycloakUtils.buildAuthRequestUrl(this._serverUrl, this._realm);
      const data = DxKeycloakUtils.prepareAuthRequestData(this._clientId, login, password);
      const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

      this._http.post(path, data, {headers: headers, observe: 'response'}).subscribe(response => {
        authentication.authResult = DxOperationResultType.SUCCESS;

        // получили токен доступа
        const token = response.body[DxKeycloakAuthenticationStrategy.KEYCLOAK_ACCESS_TOKEN];
        let rawData = this._encryptor.decode(token, DxEncryptionStrategyType.KEYCLOAK);
        authentication.user = this._mapper.deserialize<DxKeycloakUser>(rawData, DxKeycloakUser);
        (<DxKeycloakUser>authentication.user).token = token;
        (<DxKeycloakUser>authentication.user).roles = this._parseUserRoles(rawData);

        // и токен для обновлени токена
        const refreshToken = response.body[DxKeycloakAuthenticationStrategy.KEYCLOAK_REFRESH_TOKEN];
        (<DxKeycloakUser>authentication.user).refreshToken = refreshToken;
        rawData = this._encryptor.decode(refreshToken, DxEncryptionStrategyType.KEYCLOAK);
        (<DxKeycloakUser>authentication.user).refreshTokenExpTime = rawData[DxKeycloakAuthenticationStrategy._KEYCLOAK_TOKEN_EXP_TIME];

        resolve(authentication);
      }, errorResponse => {
        const error = DxHttpDispatcher.handleHttpError(errorResponse);
        authentication.authResult = DxOperationResultType.FAILED;
        authentication.error = error.message;
        resolve(authentication);
      })
    });
    return fromPromise(promise);
  }


  /**
   * Достает из токена информацию о ролях пользователя
   * @param rawData { Object } - расшифрованные данные токена
   * @return { DxUserRole[] } - результирующий массив ролей
   * @private
   */
  private _parseUserRoles(rawData: Object): DxUserRole[] {
    const roles: DxUserRole[] = [];
    let rawRoles: string[] = [];
    if (rawData['resource_access'][this._clientId] && rawData['resource_access'][this._clientId]['roles']) {
      rawRoles= rawData['resource_access'][this._clientId]['roles'];
    }
    rawRoles.forEach(role => {
      let addRole: DxUserRole = new DxUserRole();
      addRole.ident = role;
      roles.push(addRole);
    });
    return roles;
  }

}

